import { useState, useEffect } from 'react';
import { useCommunityStats } from '../hooks/useCommunityStats';
import { useRankingResultado } from '../hooks/useRankingResultado';
import DailyCounter from '../components/community/DailyCounter';
import WeeklyPrompt from '../components/community/WeeklyPrompt';
import Leaderboard from '../components/community/Leaderboard';
import ModalResultadoRanking from '../components/community/ModalResultadoRanking';
import MetricasComunidade from '../components/community/MetricasComunidade';
import FeedReflexoes from '../components/community/FeedReflexoes';
import MoodColetivo from '../components/community/MoodColetivo';
import ReflexaoEmDestaque from '../components/community/ReflexaoEmDestaque';

const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

const WHATSAPP_LINK = 'https://chat.whatsapp.com/Dc3INZBnb9zA4rwgqoRHiy?mode=gi_t';

const WhatsAppIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

export default function CommunityPage({ user }) {
  const {
    todayCount,
    weeklyPrompt,
    leaderboard,
    userOptedIn,
    userRank,
    loading,
    toggleOptIn,
  } = useCommunityStats(user.id);

  const { resultado, showModal, dismiss } = useRankingResultado(user.id);
  const [modalAberto, setModalAberto] = useState(false);

  useEffect(() => {
    if (showModal) setModalAberto(true);
  }, [showModal]);

  function fecharModal() {
    dismiss();
    setModalAberto(false);
  }

  const mesAnteriorNome = MESES[(new Date().getMonth() - 1 + 12) % 12];

  return (
    <div className="community-page">
      {modalAberto && resultado && (
        <ModalResultadoRanking resultado={resultado} onClose={fecharModal} />
      )}

      <div className="section" style={{ marginTop: 8, marginBottom: 20 }}>
        <h1 style={{ marginBottom: 4, color: 'var(--navy)' }}>Comunidade</h1>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 300, color: 'var(--muted)' }}>
          a ambiência é o motor da mudança individual.
        </p>
      </div>

      {/* WhatsApp */}
      <div className="section">
        <div style={{
          background: '#25D366', borderRadius: 16, padding: '18px 20px',
          display: 'flex', alignItems: 'center', gap: 14,
        }}>
          <div style={{ color: '#fff', flexShrink: 0 }}>
            <WhatsAppIcon />
          </div>
          <div style={{ flex: 1 }}>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 15, fontWeight: 600, color: '#fff', marginBottom: 2 }}>
              Grupo do WhatsApp
            </p>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: 'rgba(255,255,255,0.85)' }}>
              Participe da nossa comunidade e escreva junto com outras pessoas.
            </p>
          </div>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              background: '#fff', color: '#25D366', border: 'none', borderRadius: 50,
              padding: '8px 16px', fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 600,
              textDecoration: 'none', whiteSpace: 'nowrap', flexShrink: 0,
            }}
          >
            Entrar
          </a>
        </div>
      </div>

      {/* Hoje no clube */}
      <div className="section">
        <p className="section-title">Hoje no clube</p>
        <DailyCounter count={todayCount} loading={loading} />
      </div>

      {/* Mood coletivo — gerencia próprio margin-bottom, sem section wrapper */}
      <MoodColetivo />

      {/* Reflexão em destaque — gerencia próprio margin-bottom, sem section wrapper */}
      <ReflexaoEmDestaque />

      {/* Ranking do mês */}
      <div className="section">
        <Leaderboard
          rows={leaderboard}
          userOptedIn={userOptedIn}
          onToggleOptIn={toggleOptIn}
          loading={loading}
          userId={user.id}
          userRank={userRank}
          onVerResultado={resultado ? () => setModalAberto(true) : undefined}
          mesAnteriorNome={resultado ? mesAnteriorNome : undefined}
        />
      </div>

      {/* Feed de reflexões */}
      <div className="section" id="feed-reflexoes">
        <p className="section-title">Reflexões da comunidade</p>
        <FeedReflexoes userId={user.id} />
      </div>

      {/* Métricas */}
      <div className="section">
        <MetricasComunidade />
      </div>

      {/* Prompt da semana */}
      {weeklyPrompt && (
        <div className="section">
          <p className="section-title">Prompt da semana</p>
          <WeeklyPrompt prompt={weeklyPrompt} />
        </div>
      )}
    </div>
  );
}
